import md5 from 'md5'
import encryptV2 from './encryptV2';
import { KeyVerEnums } from "@/const";
import { appVersionStatus, getVersion } from '@/utils/ua';

var encryptV1 = function (params, resolve) {
    var Param = params;
    // Param.sTime = parseInt(new Date().getTime() / 1000);
    //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，sortArr是一个数组
    var sortKeyArr = Object.keys(params).sort();
    var sortArr = [], sortStr;

    sortKeyArr.forEach(function (item, index) {
        sortArr[index] = item + '=' + params[item]
    })

    sortStr = sortArr.join('&');

    const pubKey = 'jkl25488f745a1c5d3701g1afa7w4r5t';
    Param.privateSign = md5(sortStr + pubKey).toLowerCase();
    // Param.sign = md5(sortStr);
    // Param.privateSign = md5(`${sortStr}fc925488f745a1c5d370111afa53e8ce`);
    resolve(Param);
}
const appVersion = getVersion();

export const versionStatus = appVersionStatus(
    KeyVerEnums.SUPPORT_SIGN_V2,
    KeyVerEnums.SUPPORT_SIGN_V2,
    { appVersion }
);
function encrypt(params) {
    let resolve;
    const promise = new Promise((res) => {
        resolve = res;
    });
    const func = versionStatus ? encryptV2 : encryptV1;
    func({ ...params, appVersion }, resolve);
    return promise;
}
export default encrypt



// WEBPACK FOOTER //
// ./src/components/plugin/lib/encrypt.js